import styled from "styled-components";
import theme from "../../../styles/theme";

import { useEffect } from 'react';
import { useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import { useGetStaticItemSum } from "../../../interface/item";
import { useState } from 'react';
import { NumericFormatCustom } from "../dashboard/common";
import CommonDataGrid from "../../common/CommonDataGrid";
import { useGetCategoryList } from "../../../interface/common";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useGetInoutStatusStatic } from "../../../interface/inout";

const MainWrap = styled.div`
    padding: 0.25rem 1.5rem; 
    h3 {
        font-size: ${theme.fontSize.base};
        font-weight: 600;
        margin: 0;
        color: ${theme.color.black};
    }
`;

const staticItemColumn = [
    { field: 'cat_nm', headerName: '분류', width:120},
    { field: 'tot_cnt', headerName: '전체', width:90, renderCell:NumericFormatCustom },
    { field: 'use_tot_cnt', headerName: '사용중', width:90, renderCell:NumericFormatCustom },
    { field: 'use_scnt', headerName: '조사반출', width:90, renderCell:NumericFormatCustom },
    { field: 'use_fcnt', headerName: '수리중', width:90, renderCell:NumericFormatCustom },
    { field: 'use_ecnt', headerName: '고장/파손', width:90, renderCell:NumericFormatCustom },
    { field: 'use_xcnt', headerName: '분실/도난', width:90, renderCell:NumericFormatCustom },
    { field: 'not_cnt', headerName: '기타', width:90, renderCell:NumericFormatCustom },
]

const StaticSearchItem = () => {

    const navigate = useNavigate();

    const [searchParams] = useSearchParams();

    const [cid, setCid] = useState(searchParams.get('cid'));

    const [list, setList] = useState([]);
    const [pCatelist, setPCateList] = useState([]);

    const {data: staticInoutStatus, isLoading: staticInoutStatusLoading} = useGetInoutStatusStatic();
    const {data : categoryList} = useGetCategoryList();

    useEffect(()=>{
        if(staticInoutStatus){
            const temp = staticInoutStatus.filter((item)=> item.cid !== null);
            setList(temp.map((item,index)=>({id:index,...item})));
        }
    },[staticInoutStatus])

    useEffect(()=>{
        if(categoryList && categoryList[0]){
        const temp = categoryList[0].filter((item)=>item.pcid===null);
        setPCateList(temp)}
    },[categoryList])

    // useEffect(()=>{
    //     refetch();
    // },[cid])

    const handleRowClick = (e) => {
        navigate('/admin/items',{state: {...e.row}})
    }

    return (
        <MainWrap>
            <h3>조사장비</h3>
            <div style={{height:'8px'}} />
            <div style={{height:'85vh'}}>
            <CommonDataGrid
                    isLoading={staticInoutStatusLoading}
                    list={list}
                    columns={staticItemColumn}
                    showCount={list.length}
                    onRowClick={handleRowClick}
                />
            </div>
        </MainWrap>
    )

}

export default StaticSearchItem;